module.exports = __webpack_public_path__ + "static/img/g_hands_ok.d75ffe07.webp";